export const donorConnectTabs = {
    UNASSIGNED: 'UNASSIGNED',
    TODO: 'TODO',
    MINE: 'MINE',
    ALL: 'ALL'
};